import { createSlice } from '@reduxjs/toolkit';

const loadWishlistFromLocalStorage = () => {
  try {
    const saved = localStorage.getItem('wishlistItems');
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    console.error('Error loading wishlist from localStorage:', error);
  }
  return [];
};

const saveWishlistToLocalStorage = (items) => {
  try {
    localStorage.setItem('wishlistItems', JSON.stringify(items));
  } catch (error) {
    console.error('Error saving wishlist to localStorage:', error);
  }
};

const initialItems = loadWishlistFromLocalStorage();

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState: {
    wishlistItems: initialItems,
    totalQuantity: initialItems.length,
  },
  reducers: {
    toggleWishlist: (state, action) => {
      const item = action.payload;
      const existingIndex = state.wishlistItems.findIndex((i) => i.id === item.id);

      if (existingIndex >= 0) {
        state.wishlistItems.splice(existingIndex, 1);
      } else {
        state.wishlistItems.push({
          id: item.id,
          productName: item.productName,
          price: item.price,
          imgUrl: item.imgUrl,
          category: item.category,
        });
      }

      state.totalQuantity = state.wishlistItems.length;
      saveWishlistToLocalStorage(state.wishlistItems);
    },
    removeFromWishlist: (state, action) => {
      const id = action.payload;
      state.wishlistItems = state.wishlistItems.filter((i) => i.id !== id);
      state.totalQuantity = state.wishlistItems.length;
      saveWishlistToLocalStorage(state.wishlistItems);
    },
    setWishlist: (state, action) => {
      const items = action.payload || [];
      state.wishlistItems = items;
      state.totalQuantity = items.length;
      saveWishlistToLocalStorage(state.wishlistItems);
    },
    clearWishlist: (state) => {
      state.wishlistItems = [];
      state.totalQuantity = 0;
      localStorage.removeItem('wishlistItems');
    },
  },
});

export const wishlistActions = wishlistSlice.actions;
export default wishlistSlice.reducer;
